
    // this file was auto generated by python script
    import FileMinus from './FileMinus';
    export default FileMinus;
    